import React, { useState } from "react";
import PropTypes from "prop-types";

import { reusableComponentSizes } from "core/props";

import { getValidationError } from "core/Form/helpers";

import colors from "core/colors";
import SrOnly from "core/SrOnly";
import { FormElementContainer } from "core/Form";
import { Select } from "./styles";

const FormSelect = ({
    className,
    placeholderText = "Select Option",
    labelText,
    onChange,
    validation,
    darkMode = false,
    size = "md",
    width = "100%",
    isDisabled = false,
    options,
    selectName,
    ...selectMenuProps
}) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [success, setSuccess] = useState(false);
    const [textColor, updateTextColor] = useState(colors.secondary.oolong);

    const validateInput = input => {
        const validationError = getValidationError({ input, validation });

        setErrorMessage(validationError);
        setSuccess(validationError ? false : true);
    };

    const handleChange = e => {
        e.preventDefault();

        updateTextColor(
            darkMode ? colors.primary.diamond : colors.secondary.orca
        );

        e.target && // check to see if theres a target
        e.target.value && // check to see if target has a value
        e.target.value !== placeholderText && // make sure value isnt the placeholder (first option) value
            onChange(e.target.value);
    };

    const handleBlur = e => {
        if (validation) validateInput(e.target.value);
    };

    return (
        <FormElementContainer
            className={className}
            width={width}
            darkMode={darkMode}
            labelText={labelText}
            showFormLabel={false}
            errorMessage={errorMessage}
        >
            <SrOnly>{labelText}</SrOnly>
            <Select
                name={selectName}
                size={size}
                defaultValue={placeholderText}
                onChange={handleChange}
                onBlur={handleBlur}
                width={width}
                darkMode={darkMode}
                disabled={isDisabled}
                textColor={textColor}
                {...selectMenuProps}
            >
                <option value={placeholderText} disabled>
                    {placeholderText}
                </option>

                {options.map((item, index) => (
                    <option key={index} value={item.option}>
                        {item.option}
                    </option>
                ))}
            </Select>
        </FormElementContainer>
    );
};

FormSelect.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({ option: PropTypes.string.isRequired })
    ).isRequired,
    selectName: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    labelText: PropTypes.string.isRequired,
    validation: PropTypes.arrayOf(
        PropTypes.shape({
            isValid: PropTypes.func,
            errorMsg: PropTypes.string
        })
    ),
    placeholderText: PropTypes.string,
    size: PropTypes.oneOf(reusableComponentSizes),
    width: PropTypes.string,
    darkMode: PropTypes.bool,
    isDisabled: PropTypes.bool,
    errorMessage: PropTypes.string
};

export default FormSelect;
